
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Category } from '../types';

interface CategoryFormFieldsProps {
  category: Partial<Category>;
  onNameChange: (name: string) => void;
  onCategoryChange: (category: Partial<Category>) => void;
}

export const CategoryFormFields: React.FC<CategoryFormFieldsProps> = ({
  category,
  onNameChange,
  onCategoryChange,
}) => {
  return (
    <div className="space-y-4 py-2">
      <div className="space-y-2">
        <Label htmlFor="name">Category Name</Label>
        <Input 
          id="name" 
          value={category.name || ''} 
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Enter category name"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="slug">Slug</Label>
        <Input 
          id="slug" 
          value={category.slug || ''} 
          onChange={(e) => onCategoryChange({...category, slug: e.target.value})}
          placeholder="Enter URL-friendly slug"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description">Description (Optional)</Label>
        <Textarea 
          id="description" 
          value={category.description || ''} 
          onChange={(e) => onCategoryChange({...category, description: e.target.value})}
          placeholder="Enter category description"
        />
      </div>
      
      <div className="flex items-center space-x-2">
        <Switch 
          id="active" 
          checked={category.active !== false} 
          onCheckedChange={(checked) => onCategoryChange({...category, active: checked})}
        />
        <Label htmlFor="active">Active</Label>
      </div>
    </div>
  );
};
